import { useState } from "react"
import { useTranslation } from "react-i18next"

interface MapSearchBarProps {
  onSearch: (lat: number, lng: number, name: string) => void
}

export default function MapSearchBar({ onSearch }: MapSearchBarProps) {
  const { t } = useTranslation()
  const [query, setQuery] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!query.trim()) return
    setLoading(true)
    setError(null)
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1`
      )
      const data = await res.json()
      if (data && data.length > 0) {
        const result = data[0]
        onSearch(parseFloat(result.lat), parseFloat(result.lon), result.display_name)
      } else {
        setError(t("search.noResults"))
      }
    } catch {
      setError(t("error.generic"))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="absolute top-4 left-4 z-20 w-1/2 max-w-xs">
      <form onSubmit={handleSubmit} className="flex gap-1.5">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={t("map.searchPlaceholder")}
          className="flex-1 min-w-0 px-3 py-2 rounded-lg shadow-md bg-white dark:bg-slate-800 text-gray-900 dark:text-white border border-gray-200 dark:border-slate-600 focus:outline-none focus:ring-2 focus:ring-steel text-sm"
        />
        <button
          type="submit"
          disabled={loading}
          className="px-3 py-2 rounded-lg shadow-md bg-steel text-white font-medium hover:bg-steel-dark disabled:opacity-50 text-sm"
          aria-label={t("search.search")}
        >
          {loading ? "⋯" : "🔍"}
        </button>
      </form>
      {error && (
        <p className="mt-1.5 px-3 py-1.5 rounded-md bg-red-100 text-red-700 text-xs">{error}</p>
      )}
    </div>
  )
}
